import { CommonObjectModel, IGenericObject } from "../common";
import { PersonEditModel } from "./person-edit.model";

export class PersonPreviewModel extends PersonEditModel {
    PersonFunctionInfo: IGenericObject;
    CompanyDepartmentInfo: IGenericObject;
    SiteInfo: any;
    ManagerInfo: any;
    StatusInfo: IGenericObject;
    MaritalStatusInfo: CommonObjectModel;
    DepartmentInfo: any;
    PreferredConfirmationInfo: CommonObjectModel;
    OriginalContactInfo: IGenericObject;
    CountryInfo: IGenericObject;
    FunctionInfo: any;
}